import React, { Component } from "react";
import { Route } from "react-router-dom";
import Cookies from "js-cookie";
import myLoadable from "../myLoadable";
import intl from "react-intl-universal";
import "./Authrization.less";
import Footer from '../components/Footer/index'
import LangSelect from '../components/LangSelect';
import Login from '../login/Login';
import util from '../utils/utils';

// const asyncLogin = myLoadable({
//   loader: () => import("../login/Login")
// });

const asyncResetPassword = myLoadable({
  loader: () => import("../resetPassword/ResetPassword")
});
const asyncRegister = myLoadable({
  loader: () => import("../register/Index")
});
const asyncThirdPartLogin = myLoadable({
  loader: () => import('../thirdPartLogin/ThirdPartLogin')
})

// 定制配置
const logo = util.bizConfig.logo || 'https://resource.eziot.com/group2/M00/00/59/CtwQFmBh0iuAWGNqAAAKzpFva8U841.png';
const loginBackground = util.bizConfig.loginBackground || 'https://resource.eziot.com/group2/M00/00/58/CtwQF2BODVSAJjAQAA8VSNZq0Z4139.png';
const contentStyle = {backgroundImage: `url(${loginBackground})`}
const hideCopyright = util.bizConfig.hideCopyright;

function Authrization(props) {
  return (
    <div className="authrization">
      <div className="header">
        <img src={logo} alt="logo" />
        <LangSelect />
      </div>

      <div className="content" style={contentStyle}>
        <Route path="/" component={Login} exact />
        <Route path="/authrization" component={Login} exact />
        <Route path="/authrization/login" component={Login} />
        <Route path="/authrization/thirdPathLogin" component={asyncThirdPartLogin} />
        <Route path="/authrization/register/:id" component={asyncRegister} />
        <Route path="/authrization/resetPassword/:id" component={asyncResetPassword} />
      </div>
      {/* <ThirdPartLogin /> */}
      {!hideCopyright && <Footer />}
    </div>
  );
}


export default Authrization;
